export default __webpack_public_path__ + "static/media/image-plane.03db115d.jpg";